module.exports = __webpack_public_path__ + "static/media/HuntingtonBrass.2eb5b9ed.svg";